import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { IconButton } from "@mui/material";
import deleteIcon from '../../assets/images/delete.svg';
import locationIcon from "../../assets/images/location.svg";
import { deleteVisitLocation } from "../../actions/userActions/VisitProfileAction";
import CancelButton from "../subComponents/buttons/CustomCancelButton";
import PrimaryButton from "../subComponents/buttons/PrimaryButton";
import { toast } from 'react-toastify';
import Heading6Semibold from "../designSystem/Heading6Semibold";
import BodyMediumRegular from "../designSystem/BodyMediumRegular";
import SingleSelect from "../designSystem/SingleSelect";
import { error } from "jquery";
import MultiSelect from "../designSystem/MultiSelect";

import practicelocationicon from "../../assets/images/practicelocationicon.svg";
import { getPracticeLocations } from "../../actions/userActions/practiceLocationAction";
import AddNewForm from "../addNew/AddNewForm";
import AddNewDrawer from "../addNew/AddNewDrawer";

import { t } from "../../locales/translate";

function VisitlocationsRow(props) {
    const [openModal, setOpenModal] = useState(false);
    const [rowIndexToDelete, setRowIndexToDelete] = useState(null);
    const dispatch = useDispatch();
    const [drawerOpen, setDrawerOpen] = useState(false);
      const [drawerItem , setDrawerItem] = useState(null);
    const handleRowChange = (rowIndex, field, value) => {
        if (field === "practiceLocation") {
            const locationAlreadyExists = props.formValues.rows.some(
                (row, index) => index !== rowIndex && row.practiceLocation === value
            );

            if (locationAlreadyExists) {
                toast.error("This target location already exists in another row.");
                return;
            }
            props.setFormValues((prevState) => ({
                ...prevState,
                rows: prevState.rows.map((row, index) =>
                    index === rowIndex ? { ...row, doctors: [] } : row
                ),
            }));
        }
        props.setFormValues((prevState) => ({
            ...prevState,
            rows: prevState.rows.map((row, index) =>
                index === rowIndex
                    ? {
                        ...row,
                        [field]:
                            field === "doctors"
                                ? [...(row[field] || []), value]
                                : value,
                    }
                    : row
            ),
        }));
    };
    const handleDeleteClick = (rowIndex) => {
        const row = props.formValues.rows[rowIndex];
        if (row.visitLocationId) {
            setRowIndexToDelete(rowIndex);
            setOpenModal(true);
        } else {
            props.setFormValues((prevState) => ({
                ...prevState,
                rows: prevState.rows.filter((_, index) => index !== rowIndex),
            }));
        }
    };

    const handleAddNew = (itemName) => {
  setDrawerItem(itemName);
      setDrawerOpen(true);
    };
    
    const handleConfirmDelete = async () => {
        const visitProfile = props.formValues.rows[rowIndexToDelete];
        try {
            await dispatch(deleteVisitLocation(visitProfile.visitLocationId));
            props.setFormValues((prevState) => ({
                ...prevState,
                rows: prevState.rows.filter((_, index) => index !== rowIndexToDelete),
            }));
        } catch (error) {
            console.error("Error while deleting:", error);
        } finally {
            setOpenModal(false);
        }
    };
    
    const handleCancelDelete = () => {
        setOpenModal(false);
    };
    const handleMultiSelectRowChange = (rowIndex, values) => {
        props.setFormValues((prevState) => ({
            ...prevState,
            rows: prevState.rows.map((row, index) =>
                index === rowIndex
                    ? {
                        ...row,
                        doctors: values
                    }
                    : row
            ),
        }));
    };
    const handleDeleteDoctor = (doctorId) => {
        const updatedDoctors = props.row.doctors.filter((doctor) => doctor !== doctorId);
        handleRowChange(props.index, "doctors", updatedDoctors);
    };

    const getOptions = (type) => {
        if (type === "practiceLocations") {
            if (
                props.visitProfileData &&
                props.visitProfileData !== "isLoading" &&
                props.visitProfileData.result
            ) {
                const locations = [];
                const addedIds = new Set();
                props.visitProfileData.result.forEach(profile => {
                    profile.visitLocations.forEach(visitLoc => {
                        const location = visitLoc.practiceLocation;
                        if (!addedIds.has(location.id)) {
                            addedIds.add(location.id);
                            locations.push({
                                value: location.id,
                                label: location.name,
                                subtext: location.typeName && location.address ?
                                    `${location.typeName} - ${location.address}` :
                                    (location.typeName || location.address || "")
                            });
                        }
                    });
                });
                return locations.sort((a, b) => a.label.localeCompare(b.label));
            }
            return [];
        }
        if (type === "doctors") {
            if (
                props.visitProfileData &&
                props.visitProfileData !== "isLoading" &&
                props.visitProfileData.result &&
                props.row.practiceLocation
            ) {
                let doctors = [];
                props.visitProfileData.result.forEach(profile => {
                    profile.visitLocations.forEach(visitLoc => {
                        if (visitLoc.practiceLocation.id === props.row.practiceLocation) {
                            doctors = (visitLoc.practiceLocation.doctors || []).map(doctor => ({
                                value: doctor.id,
                                label: doctor.name,
                                 subtext: doctor.specializationName || ""
                            }));
                        }
                    });
                });
                return doctors.sort((a, b) => a.label.localeCompare(b.label));
            }
            return [];
        }
        return [];
    };

    return (
        <>
            <div key={`${props.row.practiceLocation}-${props.index}`} className="p-3 mb-3 maindiv">
                <div className="add-visit-profile-rounded-fields-container">
                    <div className="row align-items-center">
                        <div className="col-6">
                            <SingleSelect
                                label= {`${t("practiceLocation")} *`}
                                isSearchable
                                secondaryLabel
                                iconEnd
                                error={props.formErrors?.rows?.[props.index]?.practiceLocation}
                                onChange={(e) => handleRowChange(props.index, "practiceLocation", e.value)}
                                value={props.row.practiceLocation}
                                placeholder={t("practiceLocation")}
                                options={getOptions("practiceLocations")}
                                configKey={"practiceLocation"}
                               onAddNewClick={() => handleAddNew("practiceLocation")}
                            />

                        </div>
                        <div className="col-6">
                            <MultiSelect
                                label={`${t("doctor")} *`}
                                isSearchable
                                secondaryLabel
                                iconEnd
                                error={props.formErrors?.rows?.[props.index]?.doctors}
                                onChange={(values) => handleMultiSelectRowChange(props.index, values)}
                                value={props.row.doctors}
                                placeholder={t("doctor")}
                                options={getOptions("doctors")}
                            />
                        </div>
                    </div>
                </div>

                <div className="removeIcon">
                    {props.index > 0 && (
                        <IconButton onClick={() => handleDeleteClick(props.index)}>
                            <img src={deleteIcon} alt="Delete" style={{ width: '24px', height: '24px' }} />
                        </IconButton>
                    )}
                </div>
            </div>


            {openModal && (
                <div className="custom-modal">
                    <div className="modal-content">
                        <div className="modal-img">
                            <img src={locationIcon} alt="Location Icon" className="modal-icon" />
                        </div>
                        <div className='text-container'>
                            <Heading6Semibold color='#1E293B' text='Delete Location' />
                            <BodyMediumRegular
                                color='#384153'
                                text='This target location along with all the customers will be deleted and plans created against these doctors will be affected.
                        Are you sure you want to delete?'
                                textAlign='center'
                            />
                        </div>

                        <div className="modal-buttons">
                            <CancelButton onClick={handleCancelDelete} text="Cancel" />
                            <PrimaryButton onClick={handleConfirmDelete} text="Delete" color="#C81E1E" />

                        </div>
                    </div>
                </div>
            )}
              <AddNewDrawer
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          title={`Add ${drawerItem  ? drawerItem .charAt(0).toUpperCase() + drawerItem .slice(1) : ""}`}
          subtext={drawerItem ? t("createNewItemRecord").replace(/{{item}}/g, t(drawerItem)) : ""}
          icon={drawerItem  === "practiceLocation" ? <img src={practicelocationicon} alt={drawerItem } /> : null}
        >
          {drawerItem  && (
           <AddNewForm
              itemName={drawerItem }
              onClose={() => setDrawerOpen(false)}
              onSave={(newData) => {
               if (drawerItem === "practiceLocation") {
                         dispatch(getPracticeLocations()).then(() => {
                           setFormValues((prev) => ({
                             ...prev,
                             practiceLocationId: newData.id,
                             practiceLocationName: newData.name
                           }));
                         });
                       }
              }}
            />

          )}
</AddNewDrawer>
        </>
    );
}
export default VisitlocationsRow;
